import {Doughnut} from "vue-chartjs";
import updateChartMixin from "@/components/widgets/updateChartMixin";

export default {
    extends: Doughnut,
    mixins: [updateChartMixin],
    props: {
        options: {
            type: Object,
            default: () => null
        },
        unApprovedPassengersWithoutIdsToday: {
            type: Number,
            required: true
        },
        unApprovedPassengersWithIdsToday: {
            type: Number,
            required: true
        }
    },
    computed: {
        data() {
            return {
                datasets: [{
                    label: "Unapproved Passengers Today",
                    data: [this.unApprovedPassengersWithIdsToday, this.unApprovedPassengersWithoutIdsToday],
                    backgroundColor: ["#F00", "#F0F"]
                }],
                labels: ['With IDS', 'Without IDS']
            }
        }
    },
    mounted() {
        this.renderChart(this.data, this.options);
    }
};